import { render, staticRenderFns } from "./cities-regions.vue?vue&type=template&id=4574f973&"
import script from "./cities-regions.vue?vue&type=script&lang=js&"
export * from "./cities-regions.vue?vue&type=script&lang=js&"
import style0 from "./cities-regions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QPagination,QTable,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QPagination,QTable,QIcon})
